/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  GET_REGIONS = '[Account] Get Regions',
  GET_REGIONS_SUCCESS = '[Account] Get Regions Success',
  GET_REGIONS_FAILED = '[Account] Get Regions Failed',

  GET_PROVINCES = '[Account] Get Provinces',
  GET_PROVINCES_SUCCESS = '[Account] Get Provinces Success',
  GET_PROVINCES_FAILED = '[Account] Get Provinces Failed',

  GET_CITIES = '[Account] Get Cities',
  GET_CITIES_SUCCESS = '[Account] Get Cities Success',
  GET_CITIES_FAILED = '[Account] Get Cities Failed',

  GET_BARANGAYS = '[Account] Get Barangays',
  GET_BARANGAYS_SUCCESS = '[Account] Get Barangays Success',
  GET_BARANGAYS_FAILED = '[Account] Get Barangays Failed',
}

export const getRegions = createAction(
  ActionTypes.GET_REGIONS
);

export const getRegionsSuccess = createAction(
	ActionTypes.GET_REGIONS_SUCCESS,
  props<{ data: any }>()
);

export const getRegionsFailed = createAction(
	ActionTypes.GET_REGIONS_FAILED,
  props<{ data: any }>()
);

export const getProvinces = createAction(
  ActionTypes.GET_PROVINCES,
  props<{ regCode: any }>()
);


export const getProvincesSuccess = createAction(
  ActionTypes.GET_PROVINCES_SUCCESS,
  props<{ data: any }>()
);

export const getProvincesFailed = createAction(
	ActionTypes.GET_PROVINCES_FAILED,
  props<{ data: any }>()
);

export const getCities = createAction(
  ActionTypes.GET_CITIES,
  props<{ provCode: Boolean }>()
);

export const getCitiesSuccess = createAction(
	ActionTypes.GET_CITIES_SUCCESS,
  props<{ data: any }>()
);

export const getCitiesFailed = createAction(
  ActionTypes.GET_CITIES_FAILED,
  props<{ data: any }>()
);

export const getBarangays = createAction(
  ActionTypes.GET_BARANGAYS,
  props<{ cityCode: any }>()
);

export const getBarangaysSuccess = createAction(
	ActionTypes.GET_BARANGAYS_SUCCESS,
  props<{ data: any }>()
);

export const getBarangaysFailed = createAction(
  ActionTypes.GET_BARANGAYS_FAILED,
  props<{ data: any }>()
);